import { defineStore } from "pinia";
import Services from '@/services/skillServices'
import { mapSkill } from '@/helpers/mapFuncs'

export const useSkillsPersonStore = defineStore("skillsPerson", {

state:()=>({
    skill: {},
    skills: [],
}),
getters : {
    getSkill() {
        return mapSkill(this.skill)
    },
    getSkills() {
        return this.skills.map(mapSkill)
    }
},
actions : {
    /** Start Sets */
    setSkill(skill) {
        this.skill = skill
    },
    setSkills(skills) {
        this.skills = skills
    },
    /** End Sets */

    /** Start Actions */
    getByPersonId(data){
        return Services.getByPersonId(data)
        .then((response)=>{
            this.skills = response.data.data;
            return response.data.data.map(mapSkill)
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.skills = response.data.data;
            return response.data.data.map(mapSkill)
            // this.skills.push(response.data.data)
            // return mapSkill(response.data.data);
        })
    },
    edit(data){
        return Services.update(data)
        .then((response)=>{
            this.skills = response.data.data;
            return response.data.data.map(mapSkill)
        })
    },
    delete(data){
        return Services.delete(data)
        .then((response)=>{
            this.skills = this.skills.filter((x)=>x.id != data.skillId)
            return mapSkill(response.data.data)
        })
    },
    /** End Actions */
}
});